export const GATES = {
  INBOX_NAVIGATION: 'CustomerPortal::InboxNavigation::FE',
  UNIFIED_SHELL: 'PortalsPlatform::UnifiedShell::FE'
};